import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { useApiDocs } from './ApiDocsContext';

type Props = {
  code: string;
  /** ชื่อไฟล์/ภาษา ที่โชว์บนแถบหัว */
  label?: string;
  /** id สำหรับ state ปุ่ม Copied! (ต้องไม่ซ้ำกันทั้งหน้า) */
  id?: string;
  noCopy?: boolean;
};

/** บล็อกโค้ดสไตล์ terminal พร้อมปุ่ม copy */
const CodeBlock: React.FC<Props> = ({ code, label, id, noCopy }) => {
  const { copyCode, copiedStates } = useApiDocs();
  const copied = copiedStates[id || ''];

  return (
    <div className="api-docs-code-block rounded-xl overflow-hidden bg-[#0d1117] shadow-lg">
      {(label || !noCopy) && (
        <div className="flex items-center justify-between px-4 py-2.5 bg-[#161b22] border-b border-white/5">
          <div className="flex items-center gap-2">
            <div className="flex gap-1.5">
              <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
              <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
              <span className="w-3 h-3 rounded-full bg-[#28c840]" />
            </div>
            {label && <span className="text-gray-500 dark:text-slate-400 text-xs ml-2 font-mono">{label}</span>}
          </div>
          {!noCopy && (
            <button
              onClick={() => copyCode(code, id)}
              className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-indigo-400 transition-colors px-2 py-1 rounded hover:bg-white/5"
            >
              <FontAwesomeIcon icon={copied ? faCheckCircle : faCopy} className={copied ? 'text-emerald-400' : ''} />
              {copied ? 'Copied!' : 'Copy'}
            </button>
          )}
        </div>
      )}
      <pre className="p-4 text-[13px] leading-relaxed overflow-x-auto text-emerald-400 font-mono" style={{ tabSize: 2 }}>{code}</pre>
    </div>
  );
};

export default CodeBlock;
